import { gql } from '@apollo/client';

export const GET_PRODUCT_PORTFOLIO_RESTRICTION = gql`
    query GetProductPortfolioRestriction($contactId: String!) {
        getProductPortfolioRestriction(contactId: $contactId)
    }
`;
